import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { ignoreBracketsInToken } from '../supports.js';
import { BracketsUtils } from './richEditBrackets.js';
export var BracketElectricCharacterSupport = /*#__PURE__*/function () {
  function BracketElectricCharacterSupport(richEditBrackets) {
    _classCallCheck(this, BracketElectricCharacterSupport);

    this._richEditBrackets = richEditBrackets;
  }

  _createClass(BracketElectricCharacterSupport, [{
    key: "getElectricCharacters",
    value: function getElectricCharacters() {
      var result = [];

      if (this._richEditBrackets) {
        var _iterator = _createForOfIteratorHelper(this._richEditBrackets.brackets),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var bracket = _step.value;

            var _iterator2 = _createForOfIteratorHelper(bracket.close),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var close = _step2.value;
                var lastChar = close.charAt(close.length - 1);
                result.push(lastChar);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Filter duplicate entries


      result = result.filter(function (item, pos, array) {
        return array.indexOf(item) === pos;
      });
      return result;
    }
  }, {
    key: "onElectricCharacter",
    value: function onElectricCharacter(character, context, column) {
      if (!this._richEditBrackets || this._richEditBrackets.brackets.length === 0) {
        return null;
      }

      var tokenIndex = context.findTokenIndexAtOffset(column - 1);

      if (ignoreBracketsInToken(context.getStandardTokenType(tokenIndex))) {
        return null;
      }

      var reversedBracketRegex = this._richEditBrackets.reversedRegex;
      var text = context.getLineContent().substring(0, column - 1) + character;
      var r = BracketsUtils.findPrevBracketInRange(reversedBracketRegex, 1, text, 0, text.length);

      if (!r) {
        return null;
      }

      var bracketText = text.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
      var isOpen = this._richEditBrackets.textIsOpenBracket[bracketText];

      if (isOpen) {
        return null;
      }

      var textBeforeBracket = context.getActualLineContentBefore(r.startColumn - 1);

      if (!/^\s*$/.test(textBeforeBracket)) {
        // There is other text on the line before the bracket
        return null;
      }

      return {
        matchOpenBracket: bracketText
      };
    }
  }]);

  return BracketElectricCharacterSupport;
}();